import type { CourseModule } from "@/core/types";
import { lektionNamen } from "./lektion-01-namen";
import { lektionSchutz } from "./lektion-02-schutz";
import { lektionFreigeben } from "./lektion-03-freigeben";

export const modulNamen: CourseModule = {
  id: "namen",
  title: "Namen, Blattschutz und Zusammenarbeit",
  summary:
    "Formeln, die sich lesen lassen, Zellen, die vor Versehen sicher sind – und " +
    "eine Abstimmung, die nicht als Notizzelle im Datenbereich endet.",
  level: "Aufbau",
  lessons: [lektionNamen, lektionSchutz, lektionFreigeben],
};
